import { render, staticRenderFns } from "./role-combox.vue?vue&type=template&id=99424ce2&scoped=true"
import script from "./role-combox.vue?vue&type=script&lang=js"
export * from "./role-combox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99424ce2",
  null
  
)

export default component.exports